export const DEFAULT_LANGUAGE = 'EN' as const
export const DEFAULT_COUNTRY = 'GB' as const
